import React, { useState } from "react";
import useSWR from "swr";
import { fetcherhn } from "../../services/fectcher";
import {
  Button,
  Drawer,
  Popconfirm,
  Skeleton,
  Space,
  Table,
  Tooltip,
} from "antd";
import Search from "antd/es/input/Search";
import { FaMobileAlt } from "react-icons/fa";
import dayjs from "dayjs";
import { AddIPHospitalCommNote } from "./AddIPHospitalCommNote";
import { WarningOutlined } from "@ant-design/icons";
import { deleteCommNote } from "../../api/CareEventsApi";
import { openNotification } from "../../common/elements/myNotification";
import { handleToggle } from "../../common/elements/toggleSeeMore";
import { useMyContext } from "../../common/elements/myContext";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";
import { FiSend } from "react-icons/fi";
import SendEmail from "../../common/elements/SendEmail";

export const IPHospitalCommNote = (props) => {
  const intialReqState = {
    key: "",
    guid: "",
    mbi: props.mbiid,
    iPCommunicationNoteDateTime: dayjs().format("YYYY-MM-DD hh:mm A"),
    dateOfAdmission: "",
    hospitalName: "",
    attendingPhysician: "",
    attendingPhysicianPhoneNumber: "",
    hospitalCareManager: "",
    hospitalCareManagerPhoneNumber: "",
    admittingDiagnosis: "",
    expectedLengthOfStay: "",
    dischargeDisposition: "",
    notes: "",
    createdBy: sessionStorage.getItem("userName"),
    modifiedBy: "",
  };
  const [editRecord, setEditRecord] = useState(intialReqState);
  const { formatPhoneNumber } = useMyContext();

  const [query, setQuery] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data, mutate, isLoading } = useSWR(
    `GetIpHospitalCommunicationNote?id=${props.mbiid}`,
    fetcherhn
  );
  const handleCancel = (e) => {
    setIsModalOpen(false);
    setEditRecord(intialReqState);
  };

  const handleOk = async (e) => {
    if (e) {
      mutate();
    }
    setIsModalOpen(false);
    setEditRecord(intialReqState);
  };

  const handleDelete = async (record) => {
    const body = { ...record, modifiedBy: sessionStorage.getItem("userName") };
    const deleteResult = await deleteCommNote(body);
    if (deleteResult.status) {
      mutate();
      openNotification(
        "success",
        "Deleted",
        "Inpatient Hospital Communication Note Deleted Successfully!"
      );
    }
  };

  const [expandedRows, setExpandedRows] = useState([]);

  const [expandedRows2, setExpandedRows2] = useState([]);

  const [mail, setMail] = useState(false);

  const sendDatatoEmail = (record) => {
    setMail(true);
    setEditRecord(record);
  };

  const handleModalClose = (e) => {
    setEditRecord(intialReqState);
    setMail(false);
  };

  const edit = (record) => {
    setIsModalOpen(true);
    setEditRecord(record);
  };

  const columns = [
    {
      key: 2,
      title: "Hospital Name",
      width: 150,
      dataIndex: "hospitalName",
    },
    {
      key: 3,
      title: "Admission Date",
      dataIndex: "dateOfAdmission",
      width: 150,
    },

    {
      key: 5,
      title: "Attending Physician",
      //dataIndex: "attendingPhysician",
      width: 160,
      render: (_, { attendingPhysician, attendingPhysicianPhoneNumber }) => (
        <>
          <div>{attendingPhysician}</div>
          {attendingPhysicianPhoneNumber ? (
            <div
              style={{
                fontSize: "0.9rem",
                color: "var(--bs-gray-600)",
                marginBottom: "0.3rem",
                marginTop: "0.3rem",
                overflowWrap: "break-word",
              }}
            >
              <FaMobileAlt
                size={20}
                style={{
                  color: "var(--bs-gray-500)",
                  marginRight: "0.5rem",
                  marginTop: "-2px",
                }}
              />
              <a
                href={`tel:${formatPhoneNumber(attendingPhysicianPhoneNumber)}`}
              >
                {formatPhoneNumber(attendingPhysicianPhoneNumber)}
              </a>
            </div>
          ) : (
            ""
          )}
        </>
      ),
    },
    // {
    //   key: 6,
    //   title: "AP Phone #",
    //   dataIndex: "attendingPhysicianPhoneNumber",
    // },
    {
      key: 7,
      title: "Care/Case Manager",
      width: 160,

      render: (_, { hospitalCareManager, hospitalCareManagerPhoneNumber }) => (
        <>
          <div>{hospitalCareManager}</div>
          {hospitalCareManagerPhoneNumber ? (
            <div
              style={{
                fontSize: "0.9rem",
                color: "var(--bs-gray-600)",
                marginBottom: "0.3rem",
                marginTop: "0.3rem",
                overflowWrap: "break-word",
              }}
            >
              <FaMobileAlt
                size={20}
                style={{
                  color: "var(--bs-gray-500)",
                  marginRight: "0.5rem",
                  marginTop: "-2px",
                }}
              />
              <a
                href={`tel:${formatPhoneNumber(
                  hospitalCareManagerPhoneNumber
                )}`}
              >
                {formatPhoneNumber(hospitalCareManagerPhoneNumber)}
              </a>
            </div>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      key: 8,
      title: "Admit Dx",
      width: 300,
      dataIndex: "admittingDiagnosis",
      render: (text, record) => {
        const isExpanded = expandedRows.includes(record.key);
        const content =
          text.length > 100 ? (
            <span>
              {isExpanded ? text : `${text.substring(0, 100)}...`}
              <Button
                type="link"
                onClick={() => handleToggle(record.key, setExpandedRows)}
              >
                {isExpanded ? "See less" : "See more"}
              </Button>
            </span>
          ) : (
            text
          );

        return <div>{content}</div>;
      },
    },
    {
      key: 6,
      width: 100,
      title: "Expected LOS",
      dataIndex: "expectedLengthOfStay",
    },
    {
      key: 10,
      width: 200,
      title: "Discharge Disposition",
      dataIndex: "dischargeDisposition",
    },
    {
      key: 11,
      width: 300,
      title: "Notes",
      dataIndex: "notes",
      render: (text, record) => {
        const isExpanded = expandedRows2.includes(record.key);
        const content =
          text.length > 100 ? (
            <span>
              {isExpanded ? text : `${text.substring(0, 100)}...`}
              <Button
                type="link"
                onClick={() => handleToggle(record.key, setExpandedRows2)}
              >
                {isExpanded ? "See less" : "See more"}
              </Button>
            </span>
          ) : (
            text
          );

        return <div>{content}</div>;
      },
    },
    {
      key: "9",
      title: "IP Note Date & Time",
      width: "13%",
      render: (_, { iPCommunicationNoteDateTime, createdBy }) => {
        const [name] = createdBy.split("@");
        return (
          <>
            <div>
              {dayjs(iPCommunicationNoteDateTime).format("YYYY-MM-DD hh:mm A")}
            </div>
            <div>{name}</div>
          </>
        );
      },
    },
    {
      key: "key",
      title: "Operation",
      dataIndex: "guid",
      fixed: "right",
      width: 110,
      render: (_, record) => (
        <div>
          <Space>
            <Tooltip title="Edit">
              <FaEdit
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => edit(record)}
                color="blue"
              />
            </Tooltip>
            <Tooltip title="Delete">
              <Popconfirm
                title="Ok to Delete?"
                onConfirm={() => handleDelete(record)}
                icon={
                  <WarningOutlined
                    style={{
                      color: "red",
                    }}
                  />
                }
              >
                <FaRegTrashAlt
                  size={20}
                  className=" tw-cursor-pointer"
                  color="red"
                />
              </Popconfirm>
            </Tooltip>
            <Tooltip title="Send Email">
              <FiSend
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => sendDatatoEmail(record)}
                color="green"
              />
            </Tooltip>
          </Space>
        </div>
      ),
    },
  ];

  const finalResult = data
    ? data.filter((item) => {
        return [
          "iPCommunicationNoteDateTime",
          "dateOfAdmission",
          "hospitalName",
          "notes",
          "admittingDiagnosis",
          "hospitalCareManagerPhoneNumber",
          "hospitalCareManager",
          "expectedLengthOfStay",
          "dischargeDisposition",
          "attendingPhysicianPhoneNumber",
          "attendingPhysician",
          "createdBy",
        ].some((key) =>
          (item[key]?.toString()?.toLowerCase() ?? "").includes(
            query?.toLowerCase() ?? ""
          )
        );
      })
    : data;

  if (isLoading) {
    return <Skeleton active={isLoading} />;
  }

  return (
    <div>
      <div className="tw-flex tw-justify-between ">
        <p
          className="pt-3"
          style={{
            color: "#D2691E",
            fontWeight: "600",
          }}
        >
          IP Hospital Communication Note
        </p>

        <div className="tw-flex tw-justify-end  tw-mt-3 ">
          <Space>
            <Search
              className=" tw-mb-4"
              size="middle"
              placeholder="Search"
              onChange={(e) => setQuery(e.target.value)}
              allowClear
            />
            <Button
              type="primary"
              onClick={() => setIsModalOpen(true)}
              className="tw-mb-4 "
            >
              Add
            </Button>
          </Space>
        </div>
      </div>
      {isModalOpen && (
        <Drawer
          open={isModalOpen}
          title={"Add/Update IP Hospital Communication Note"}
          onClose={handleCancel}
          width={900}
        >
          <AddIPHospitalCommNote
            mbiid={props.mbiid}
            editRecord={editRecord}
            callback={handleOk}
          />
        </Drawer>
      )}
      <Table
        virtual
        bordered
        size="middle"
        dataSource={finalResult}
        columns={columns}
        scroll={{
          x: 2000,
          y: 1000,
        }}
      />

      {mail && (
        <SendEmail
          open={mail}
          close={handleModalClose}
          editRecord={editRecord}
          modalTitle={"Inpatient Hospital Communication Note"}
          patientName={props?.patient?.label || ""}
        />
      )}
    </div>
  );
};
